import { TopupPackageDetailModel } from "api/repositories/packagesManagement/topupManagement/model/detail/TopupDetailReponseModel";
import { ServiceDetailResponseModel } from "api/repositories/service/model/detail/ServiceDetailResponseModel";
import { BasedTransactionLog } from "../BasedTransactionLog";
import { BaseFilterListResponseModel } from "../../baseFilterListModel/BaseFilterListResponseModel";
import { BaseUserResponseModel } from "../../baseUserModel/BaseUserResponseModel";

export class BasedDetailTransactionResponseModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  type?: number;
  status?: number;
  code?: string;
  name?: string;
  transRef?: string;
  totalAmount?: string | number;
  totalPrice?: string | number;
  description?: string;
  package?: string;
  note?: string;
  order?: number;
  ownerId?: string;
  carrier?: string;
  commissionAmount?: string;
  user?: BaseUserResponseModel;
  paymentMethod?: PaymentMethodModel;
  service?: ServiceDetailResponseModel;
  transactionDetail?: TransactionDetailModel;
  product?: ProductModel;
  paymentMethods?: PaymentMethodModel;
  platform?: string;
  log?: Array<BasedTransactionLog>;

  constructor(data?: Partial<BasedDetailTransactionResponseModel>) {
    Object?.assign(this, data || {});
  }
}

class PaymentMethodModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  displayName?: string;
  code?: string;
  description?: string;
  cover?: string;
  url?: string;
  configuration?: Object;
  items?: Object;
  type?: number;
  status?: number;
  supplier?: string;

  constructor(data?: Partial<PaymentMethodModel>) {
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.id = data?.id;
    this.name = data?.name;
    this.displayName = data?.displayName;
    this.code = data?.code;
    this.description = data?.description;
    this.cover = data?.cover;
    this.url = data?.url;
    this.configuration = data?.configuration;
    this.items = data?.items;
    this.type = data?.type;
    this.status = data?.status;
    this.supplier = data?.supplier;
  }
}

export class DetailProductModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  status?: number;
  type?: number;
  description?: string;
  config?: string;
  order?: number;
  amount?: string;
  carrier?: string;
  totalAmount?: string;
  phoneNumber?: string;
  serial?: string;
  note?: string;
  sortDescription?: any;
  simType?: number;
  sim?: BaseFilterListResponseModel;
  mobileData?: TopupPackageDetailModel;

  constructor(data?: Partial<DetailProductModel>) {
    Object?.assign(this, data || {});
  }
}

export class ProductModel {
  name?: string;
  code?: string;
  totalAmount?: string | number;
  type?: number;
  detail?: DetailProductModel;

  constructor(data?: Partial<ProductModel>) {
    this.name = data?.name;
    this.code = data?.code;
    this.totalAmount = data?.totalAmount;
    this.type = data?.type;
    this.detail = data?.detail;
  }
}

class InfoInTransactionDetail {
  totalAmount?: number;
  discountRate?: number;
  discountAmount?: number;
  amount?: Array<{
    value?: number;
    name?: string;
  }>;
  resultExecute?: Record<string, any>;
  deliveryInfo?: BaseUserResponseModel;
  fullProduct?: any;
  invoiceInfo?: {
    name?: string;
    taxId?: string;
    address?: string;
    mail?: string;
  };

  constructor(data?: Partial<InfoInTransactionDetail>) {
    this.totalAmount = data?.totalAmount;
    this.discountRate = data?.discountRate;
    this.amount = data?.amount;
    this.resultExecute = data?.resultExecute;
    this.deliveryInfo = data?.deliveryInfo;
    this.invoiceInfo = data?.invoiceInfo;
  }
}

class TransactionDetailModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  description?: string;
  order?: number;
  type?: number;
  status?: number;
  note?: string;
  info?: InfoInTransactionDetail;
  buyer?: BaseUserResponseModel;

  constructor(data?: Partial<TransactionDetailModel>) {
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.id = data?.id;
    this.name = data?.name;
    this.code = data?.code;
    this.description = data?.description;
    this.order = data?.order;
    this.type = data?.type;
    this.status = data?.status;
    this.note = data?.note;
    this.info = data?.info;
    this.buyer = data?.buyer;
  }
}
